export default __webpack_public_path__ + "static/media/logoblu.87cbd573.png";